import { Stack, TooltipHost } from "@fluentui/react";
import React, { useContext, useEffect } from "react";
import ReportCount from "../../../components/SVGComponents/ReportCount";
import ImageCount from "../../../components/SVGComponents/ImageCount";
import RowBadge from "./Badge/RowBadge";
import { useNavigate } from "react-router";
import { getClientWarningStatus } from "../../../service/FirmServices";
import { t } from "i18next";
import {
  ACTIONS,
  AuthRoutes,
  CUSTOM_STYLES,
  TAB_NAME,
  USERTYPES,
} from "../../../constants/Constants";
import { RowBadgeStatic } from "./RadiologistDetails";
import userContext from "../../../context/users/UserContext";
import CustomToolTipHost from "../../../components/CustomToolTipHost/CustomToolTipHost";
import RadiologistDetails from "./RadiologistDetails";

const mainStackStyles = {
  // lineHeight: "20px",
  // height: "121px",
  // width: "210px",
  justifyContent: "center",
  marginTop: CUSTOM_STYLES.STUDYLIST_TD_TOP_MARGIN,
  // transform: "translateY(-39%)"
};

const InstitutionStackStyles = {
  fontSize: "12px",
  fontWeight: "400",
  alignItems: "top",
  marginTop: "4px",
};

const hospitalStackStyles = {
  fontSize: "14px",
  fontWeight: "400",
  alignItems: "flex-start",
  marginTop: "4px",
};

const superAdminStackStyles = {
  fontSize: "14px",
  fontWeight: "400",
  alignItems: "center",
  marginTop: "2px",
};

const modalityStyle = {
  marginLeft: "10px",
  backgroundColor: "#BBDEFF",
  height: "14px",
  fontSize: "9px",
  color: "#0035BE",
  display: "flex",
  alignItems: "center",
  width: "fit-content",
  fontWeight: "bolder",
  padding: "0px 5px",
  borderRadius: "5px",
};

const studyUploadDateStyle = {
  fontSize: "11px",
  fontWeight: "400",
};

const studyDetailsStackStyle = {
  alignItems: "center",
};

const studyDescriptionStyle = {
  fontSize: "11px",
  fontWeight: "400",
  marginRight: "20px",
};

const studyDetailsIconTextStyle = {
  fontSize: "14px",
  fontWeight: "400",
};

const ClientDetails = (props) => {
  const { roles, authenticated, loadByUsername, showConfirmation } =
    useContext(userContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (props.data.length > 0)
      if (!authenticated) {
        loadByUsername();
      }
  }, []);

  const clientDetailWithWarning = async (clientId) => {
    const response = await getClientWarningStatus(clientId);
    if (response.status == 200 && response.data.result === "SUCCESS") {
      //if (response.data.data.warning) {
      // let type = response.data.data.firmType === "Hospital" ? 0 : 1;
      let type = 0;
      let viewWarningOnly = true;
      const url =
        AuthRoutes.FIRMDETAILS +
        "?firmId=" +
        clientId +
        "&type=" +
        type +
        "&viewWarningOnly=" +
        viewWarningOnly;

      // Open the URL in a new tab
      const newTab = window.open(url, "_blank");
      if (newTab) {
        newTab.focus(); // Focus on the new tab
      }
      // }
    }
  };

  return (
    <>
      <div className="study-list-client-provider-wrapper">
        <Stack style={mainStackStyles} data-tut={"tour-client-details"}>
          {<>
            {roles[0] !== USERTYPES.ADMIN && (
              <>
              <Stack horizontal style={hospitalStackStyles}>
                <RowBadgeStatic
                  name={
                    props.data.row.original.assignmentList[0].clientName?.toLowerCase().startsWith("__p_")
                      ? "Pr"
                      : "C"
                  }
                  tooltipText={
                    props.data.row.original.assignmentList[0].clientName?.toLowerCase().startsWith("__p_")
                      ? "Project"
                      : "Client"
                  }
                />
                {props.data.row.original.assignmentList[0].clientName != undefined ? (
                  <CustomToolTipHost
                    content={`${t("navbar.client")}: ` +
                      props.data.row.original.assignmentList[0].clientName?.replace(/^(\__p_)/, "")}
                    id={
                      "tooltip_" +
                      props.data.row.original.assignmentList[0].clientName?.replace(/^(\__p_)/, "")
                    }
                  >
                    <span
                      className={`study-list-client-details-text study-list-row-badge ${(roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.SUPERVISOR)
                        ? "hover-account-warning"
                        : ""
                        } study-list-min-width`}
                      style={{ width: "120px", display: "block", lineHeight: "14px" }}
                      onClick={() => {
                        console.log("---- Clicked Account Warning ---");
                        if (
                          roles[0] === USERTYPES.FIRMADMIN ||
                          roles[0] === USERTYPES.SUPERVISOR
                        ) {
                          clientDetailWithWarning(
                            props.data.row.original.assignmentList[0].clientId
                          );
                        }
                      }}
                    >
                      &nbsp;&nbsp;
                      {props.data.row.original.assignmentList[0].clientName
                        ? props.data.row.original.assignmentList[0].clientName?.replace(/^(\__p_)/, "")
                        : "-"}
                    </span>
                  </CustomToolTipHost>
                ) : (
                  <span className="study-list-assignment-details-text study-list-row-badge">
                    &nbsp;&nbsp;-
                  </span>
                )}
              </Stack>
              {(roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.SUPERVISOR) && (
              <Stack horizontal style={InstitutionStackStyles}>
                {/* <span className="study-list-studyDetails-uploaded">Client :</span> */}
                {props.data.row.original.institutionName!=
                undefined && props.data.row.original.institutionName!=null && (
                  // <RowBadge name={props.data.row.original.assignmentList[0].clientName} />
                  <>
                  <RowBadgeStatic name="I" tooltipText="Institution Name" />
                  <CustomToolTipHost
                    content={`${t("navbar.institution")}: `+props.data.row.original.institutionName}
                    id={
                      "tooltip_" +
                      props.data.row.original.institutionName
                    }
                  >
                    <span
                      className={`study-list-assignment-details-text study-list-row-badge study-list-institution-name ${(roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.SUPERVISOR)?"hover-account-warning":""} study-list-min-width`}
                      style={{ width: "160px" }}
                    >
                      
                      {props.data.row.original.institutionName}
                    </span>
                  </CustomToolTipHost>
                  </>
                )}

                {/* <span>{props.data.row.original.assignmentList[0].clientName ? props.data.row.original.assignmentList[0].clientName : "-"}</span> */}
                {/* <div style={modalityStyle}>{props.data.row.original.modality.name}</div> */}
              </Stack>)}
                </>
            )}
            {(roles[0] === USERTYPES.ADMIN) && <Stack horizontal style={superAdminStackStyles}>
              {/* <span className="study-list-studyDetails-uploaded">Provider Firm :</span> */}
              <RowBadgeStatic
                name={
                  props.data.row.original.assignmentList[0].firmName?.toLowerCase().startsWith("__p_")
                    ? "Pr"
                    : "F"
                }
                tooltipText={
                  props.data.row.original.assignmentList[0].firmName?.toLowerCase().startsWith("__p_")
                    ? "Project"
                    : t("navbar.firm")
                }
              />
              {props.data.row.original.assignmentList[0].firmId != null ? (
                // && props.data.row.original.assignmentList[0].providerId.startsWith(
                //   "F")
                //  <RowBadge name={props.data.row.original.assignmentList[0].providerName} />
                <CustomToolTipHost
                  content={`${t("navbar.firm")}: ` + props.data.row.original.assignmentList[0].firmName.replace(/^(\__p_)/, "")}
                  id={
                    "tooltip_" +
                    props.data.row.original.assignmentList[0].firmName.replace(/^(\__p_)/, "")
                  }
                >
                  <span
                    className="study-list-assignment-details-text study-list-row-badge study-list-min-width"
                    style={{ width: "160px", display: 'block' }}
                  >
                    &nbsp;&nbsp;
                    {(props.data.row.original.assignmentList[0].firmName != "" || props.data.row.original.assignmentList[0].firmName != undefined)
                      ? props.data.row.original.assignmentList[0].firmName.replace(/^(\__p_)/, "")
                      : "-"}
                  </span>
                </CustomToolTipHost>
              ) : (
                <>
                  {roles[0] == USERTYPES.ADMIN &&
                    props.data.row.original.assignmentList[0].firmId != null &&
                    props.data.row.original.assignmentList[0].firmName != "" ? (
                    <CustomToolTipHost
                      content={props.data.row.original.assignmentList[0].firmName.replace(/^(\__p_)/, "")}
                      id={
                        "tooltip_" +
                        props.data.row.original.assignmentList[0].firmName.replace(/^(\__p_)/, "")
                      }
                    >
                      <span
                        className="study-list-assignment-details-text study-list-row-badge study-list-min-width"
                        style={{ width: "160px", display: 'block' }}
                      >
                        &nbsp;&nbsp;
                        {props.data.row.original.assignmentList[0].firmName != ""
                          ? props.data.row.original.assignmentList[0].firmName.replace(/^(\__p_)/, "")
                          : "-"}
                      </span>
                    </CustomToolTipHost>
                  ) : (
                    <span className="study-list-assignment-details-text study-list-row-badge">
                      &nbsp;&nbsp;{t("label.not-assigned")}
                    </span>
                  )}
                </>
              )}
            </Stack>}
          </>}
        </Stack>

        {/* Provider Details Section - Shown only on narrow viewports */}
        {props.isNarrowViewport && <div className="study-list-provider-info-mobile">
          {(props.roles && (props.roles[0] === USERTYPES.ADMIN || props.roles[0] === USERTYPES.FIRMADMIN || props.roles[0] === USERTYPES.SUPERVISOR)) && props.batchAssign ? (
            // Show full RadiologistDetails with real assign functionality
            <RadiologistDetails
              data={props.data}
              batchAssign={props.batchAssign}
              tabId={props.tabId}
            />
          ) : (
            // Show simple provider info for other roles
            <Stack style={mainStackStyles}>
              <Stack horizontal style={hospitalStackStyles}>
                <RowBadgeStatic
                  name={
                    props.data.row.original.assignmentList[0].providerId?.toLowerCase().startsWith("r")
                      ? "R"
                      : "P"
                  }
                  tooltipText={
                    props.data.row.original.assignmentList[0].providerId?.toLowerCase().startsWith("r")
                      ? "Radiologist"
                      : "Provider"
                  }
                />
                {props.data.row.original.assignmentList[0].providerName != undefined ? (
                  <CustomToolTipHost
                    content={`${t("navbar.provider")}: ` + props.data.row.original.assignmentList[0].providerName}
                    id={"tooltip_" + props.data.row.original.assignmentList[0].providerName}
                  >
                    <span
                      className="study-list-assignment-details-text study-list-row-badge study-list-min-width"
                      style={{ width: "120px", display: "block" }}
                    >
                      &nbsp;&nbsp;
                      {props.data.row.original.assignmentList[0].providerName
                        ? props.data.row.original.assignmentList[0].providerName
                        : "-"}
                    </span>
                  </CustomToolTipHost>
                ) : (
                  <span className="study-list-assignment-details-text study-list-row-badge">
                    &nbsp;&nbsp;-
                  </span>
                )}
              </Stack>
            </Stack>
          )}
        </div>}
      </div>
    </>
  );
};

export default ClientDetails;
